import script from "./MaterialCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialCard.vue?vue&type=script&setup=true&lang=js"

import "./MaterialCard.vue?vue&type=style&index=0&id=4396fdb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4396fdb8"]])

export default __exports__